<template>
  <div>
    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <v-flex lg12>
            <div class="page-header-left pl-3 pt-5">
                <h3>Tài khoản: {{currentItem.Username}}</h3>
            </div>
            <v-layout row wrap justify-end>
              <v-flex class="lg3">
                <v-card>
                  <v-app-bar flat dense class="hpo_color">
                    <v-toolbar-title>
                        <h5>Mua hộ chưa TT</h5>
                    </v-toolbar-title>
                  </v-app-bar>
                  <v-card-text>
                      <h4>{{currentItem.TotalUnPaidOrder | currency}}</h4>
                  </v-card-text>
                </v-card>
              </v-flex>
              <v-flex class="lg3">
                <v-card>
                  <v-app-bar flat dense class="hpo_color">
                    <v-toolbar-title>
                        <h5>Ký gửi chưa TT</h5>
                    </v-toolbar-title>
                  </v-app-bar>
                  <v-card-text>
                      <h4>{{currentItem.TotalUnPaidDeposit | currency}}</h4>
                  </v-card-text>
                </v-card>
              </v-flex>
              <v-flex class="lg3">
                <v-card>
                  <v-app-bar flat dense class="hpo_color">
                    <v-toolbar-title>
                        <h5>Dư ví</h5>
                    </v-toolbar-title>
                  </v-app-bar>
                  <v-card-text>
                      <h4>{{currentItem.Wallet | currency}}</h4>
                  </v-card-text>
                </v-card>
              </v-flex>
              <v-flex class="lg3">
                <v-card>
                  <v-app-bar flat dense class="hpo_color">
                    <v-toolbar-title>
                        <h5>Công nợ</h5>
                    </v-toolbar-title>
                  </v-app-bar>
                  <v-card-text>
                      <h4>{{currentItem.Debt | currency}}</h4>
                  </v-card-text>
                </v-card>
              </v-flex>
            </v-layout>
        </v-flex>
        <v-flex lg12>
            <div class="page-header-left pl-3 pt-5">
                <h3>Đơn mua hộ</h3>
            </div>
            <v-data-table :headers="order_headers" :fixed-header="true" height="600px" :items="orders" :options.sync="order_pagination" :server-items-length="order_rows" :footer-props="items_per_page" :must-sort="true" :loading="order_loading" :mobile-breakpoint="100">
                <template v-slot:item="{ item }">
                    <tr>
                        <td>{{ 'MD'+item.ID }}</td>
                        <td>
                            {{ item.BoughtDate | display_date('DD-MM-YYYY')}}
                            <br />
                            {{ item.BoughtDate | display_date('HH:mm:ss')}}
                        </td>
                        <td>
                            <v-chip :color="get_order_status_color(item.Status)" label outlined small> {{ item.Status | order_status}}</v-chip>
                        </td>
                        <td>{{ item.OrderCodeCN }}</td>
                        <td>{{ item.TransactionCode }}</td>
                        <td class="text-end">{{ item.AmountVND | currency }}</td>
                        <td class="text-end">{{ item.FeeShipCNVND | currency }}</td>
                        <td class="text-end">{{ item.FeeBuyAmount | currency }}</td>
                        <td class="text-end">{{ item.FeeWeightAmount | currency }}</td>
                        <td class="text-end">{{ item.FragileFeeVND | currency }}</td>
                        <td class="text-end">{{ item.CheckFeeVND | currency }}</td>
                        <td class="text-end">{{ item.FastFeeVND | currency }}</td>
                        <td class="text-end">{{ item.FeeOther | currency }}</td>
                        <td class="text-end">{{ item.DiscountVND | currency }}</td>
                        <td class="text-end">{{ item.TotalAmountVND | currency }}</td>
                        <td class="text-end">{{ item.Deposit | currency }}</td>
                        <td class="text-end">{{ item.TotalAmountVND - item.Deposit | currency }}</td>
                    </tr>
                </template>
                <template v-slot:body.append>
                    <tr class="total-summary-td">
                        <td colspan="5" class="text-center font-weight-bold">Tổng</td>
                        <td class="text-end font-weight-bold">{{ !order_summary ? 0 : order_summary.Summary.AmountVND | currency }}</td>
                        <td class="text-end font-weight-bold">{{ !order_summary ? 0 : order_summary.Summary.FeeShipCNVND | currency }}</td>
                        <td class="text-end font-weight-bold">{{ !order_summary ? 0 : order_summary.Summary.FeeBuyAmount | currency }}</td>
                        <td class="text-end font-weight-bold">{{ !order_summary ? 0 : order_summary.Summary.FeeWeightAmount | currency }}</td>
                        <td class="text-end font-weight-bold">{{ !order_summary ? 0 : order_summary.Summary.FragileFeeVND | currency }}</td>
                        <td class="text-end font-weight-bold">{{ !order_summary ? 0 : order_summary.Summary.CheckFeeVND | currency }}</td>
                        <td class="text-end font-weight-bold">{{ !order_summary ? 0 : order_summary.Summary.FastFeeVND | currency }}</td>
                        <td class="text-end font-weight-bold">{{ !order_summary ? 0 : order_summary.Summary.FeeOther | currency }}</td>
                        <td class="text-end font-weight-bold">{{ !order_summary ? 0 : order_summary.Summary.DiscountVND | currency }}</td>
                        <td class="text-end font-weight-bold">{{ !order_summary ? 0 : order_summary.Summary.TotalAmountVND | currency }}</td>
                        <td class="text-end font-weight-bold">{{ !order_summary ? 0 : order_summary.Summary.Deposit | currency }}</td>
                        <td class="text-end font-weight-bold">{{ !order_summary ? 0 : order_summary.Summary.Remain | currency }}</td>
                    </tr>
                </template>
            </v-data-table>
        </v-flex>
        <v-flex lg12>
            <div class="page-header-left pl-3 pt-5">
                <h3>Đơn ký gửi</h3>
            </div>
            <v-data-table :headers="deposit_headers" :fixed-header="true" height="600px" :items="deposits" :options.sync="deposit_pagination" :server-items-length="deposit_rows" :footer-props="items_per_page" :must-sort="true" :loading="deposit_loading" :mobile-breakpoint="100">
                <template v-slot:item="{ item }">
                    <tr>
                        <td>{{ 'KG'+item.ID }}</td>
                        <td>
                            {{ item.CreatedDate | display_date('DD-MM-YYYY')}}
                            <br />
                            {{ item.CreatedDate | display_date('HH:mm:ss')}}
                        </td>
                        <td>
                            <v-chip :color="get_order_status_color(item.Status)" label outlined small> {{ item.Status | order_status}}</v-chip>
                        </td>
                        <td class="text-end">{{ item.FeeShipVND | currency }}</td>
                        <td class="text-end">{{ item.FeeWeight | currency }}</td>
                        <td class="text-end">{{ item.GuaranteeAmountVND | currency }}</td>
                        <td class="text-end">{{ item.FragileFeeVND | currency }}</td>
                        <td class="text-end">{{ item.CheckFeeVND | currency }}</td>
                        <td class="text-end">{{ item.FeeOther | currency }}</td>
                        <td class="text-end">{{ item.DiscountVND | currency }}</td>
                        <td class="text-end">{{ item.TotalPriceVND | currency }}</td>
                        <td class="text-end">{{ item.Payment | currency }}</td>
                        <td class="text-end">{{ item.TotalPriceVND - item.Payment | currency }}</td>
                    </tr>
                </template>
                <template v-slot:body.append>
                    <tr class="total-summary-td">
                        <td colspan="3" class="text-center font-weight-bold">Tổng</td>
                        <td class="text-end font-weight-bold">{{ !deposit_summary ? 0 : deposit_summary.Summary.FeeShipVND | currency }}</td>
                        <td class="text-end font-weight-bold">{{ !deposit_summary ? 0 : deposit_summary.Summary.FeeWeight | currency }}</td>
                        <td class="text-end font-weight-bold">{{ !deposit_summary ? 0 : deposit_summary.Summary.GuaranteeAmountVND | currency }}</td>
                        <td class="text-end font-weight-bold">{{ !deposit_summary ? 0 : deposit_summary.Summary.FragileFeeVND | currency }}</td>
                        <td class="text-end font-weight-bold">{{ !deposit_summary ? 0 : deposit_summary.Summary.CheckFeeVND | currency }}</td>
                        <td class="text-end font-weight-bold">{{ !deposit_summary ? 0 : deposit_summary.Summary.FeeOther | currency }}</td>
                        <td class="text-end font-weight-bold">{{ !deposit_summary ? 0 : deposit_summary.Summary.DiscountVND | currency }}</td>
                        <td class="text-end font-weight-bold">{{ !deposit_summary ? 0 : deposit_summary.Summary.TotalPriceVND | currency }}</td>
                        <td class="text-end font-weight-bold">{{ !deposit_summary ? 0 : deposit_summary.Summary.Payment | currency }}</td>
                        <td class="text-end font-weight-bold">{{ !deposit_summary ? 0 : deposit_summary.Summary.Remain | currency }}</td>
                    </tr>
                </template>
            </v-data-table>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>
<script>
import { mapState } from "vuex";
import configs from "@/configs";
import _ from "lodash";
export default {
  data() {
    return {
      valid: true,
      payservice_statuslist: configs.PAY_SERVICE_STATUS,
      recharge_status_list: configs.RECHARGE_STATUS_LIST,
      recharge_methods: configs.RECHARGE_METHODS,
      withdraw_status_list: configs.WITHDRAW_STATUS_LIST,
      payment_type: configs.PAYMENT_STATUS_LIST,
      payment_type_enum: configs.PAYMENT_STATUS,
      order_headers: [
        {
          text: "Mã đơn",
          value: "ID"
        },
        {
          text: "Ngày mua",
          value: "BoughtDate"
        },
        {
          text: "Trạng thái",
          value: "Status"
        },
        {
          text: "Mã đơn CN",
          value: "OrderCodeCN"
        },
        {
          text: "Mã vận đơn",
          value: "TransactionCode",
          width: "50px"
        },
        {
          text: "Tiền hàng",
          value: "AmountVND",
          align: "end",
        },
        {
          text: "Ship nội địa",
          value: "FeeShipCNVND",
          align: "end",
        },
        {
          text: "Phí dịch vụ",
          value: "FeeBuyAmount",
          align: "end",
        },
        {
          text: "Phí vận chuyển",
          value: "FeeWeightAmount",
          align: "end",
        },
        {
          text: "Phí gia cố",
          value: "FragileFeeVND",
          align: "end",
        },
        {
          text: "Phí kiểm đếm",
          value: "CheckFeeVND",
          align: "end",
        },
        {
          text: "Phí hoả tốc",
          value: "FastFeeVND",
          align: "end",
        },
        {
          text: "Phí khác",
          value: "FeeOther",
          align: "end",
        },
        {
          text: "Chiết khấu",
          value: "DiscountVND",
          align: "end",
        },
        {
          text: "Tổng tiền",
          value: "TotalAmountVND",
          align: "end",
        },
        {
          text: "Đã trả",
          value: "Deposit",
          align: "end"
        },
        {
          text: "Còn thiếu",
          value: "",
          align: "end"
        }
      ],
      order_pagination: {
          ...configs.PAGINATION,
          sortBy: ["BoughtDate"]
      },
      deposit_headers: [
        {
          text: "Mã đơn",
          value: "ID"
        },
        {
          text: "Ngày đặt",
          value: "CreatedDate"
        },
        {
          text: "Trạng thái",
          value: "Status"
        },
        {
          text: "Ship nội địa",
          value: "FeeShipVND",
          align: "end",
        },
        {
          text: "Phí vận chuyển",
          value: "FeeWeight",
          align: "end",
        },
        {
          text: "Phí bảo hiểm",
          value: "GuaranteeAmountVND",
          align: "end",
        },
        {
          text: "Phí gia cố",
          value: "FragileFeeVND",
          align: "end",
        },
        {
          text: "Phí kiểm đếm",
          value: "CheckFeeVND",
          align: "end",
        },
        {
          text: "Phí khác",
          value: "FeeOther",
          align: "end",
        },
        {
          text: "Chiết khấu",
          value: "DiscountVND",
          align: "end",
        },
        {
          text: "Tổng tiền",
          value: "TotalPriceVND",
          align: "end",
        },
        {
          text: "Đã trả",
          value: "Payment",
          align: "end"
        },
        {
          text: "Còn thiếu",
          value: "",
          align: "end"
        }
      ],
      deposit_pagination: {
          ...configs.PAGINATION,
          sortBy: ["CreatedDate"]
      },
      items_per_page: _.cloneDeep(configs.ITEMS_PER_PAGE),
      filterConditions: [],
      quickFilterConditions: [],
      viewName: "bao-cao-cong-no-chi-tiet",
      summary: {}
    };
  },
  watch: {
    order_pagination: {
        handler: function (val, oldVal) {
            let filterConditions = this.$store.state.commons.filterConditions;
            this.filterConditions = !_.isEmpty(filterConditions) ? filterConditions[this.viewName] : []
            this.order_filter_data();
        },
        deep: true
    },
    deposit_pagination: {
        handler: function (val, oldVal) {
            let filterConditions = this.$store.state.commons.filterConditions;
            this.filterConditions = !_.isEmpty(filterConditions) ? filterConditions[this.viewName] : []
            this.deposit_filter_data();
        },
        deep: true
    },
  },
  computed: {
    ...mapState({
        currentItem: state => state.report.debtReportDetail,
        orders: state => state.main_order.all.data,
        order_summary: state => state.main_order.all.summary,
        order_rows: state => state.main_order.all.total,
        order_loading: state => state.main_order.loading,
        deposits: state => state.deposit.all.data,
        deposit_rows: state => state.deposit.all.total,
        deposit_loading: state => state.deposit.loading,
        deposit_summary: state => state.deposit.all.summary,
    }),
    adminRole() {
      return (this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.Admin) == configs.ROLE_TYPE.Admin;
    },
    uId() {
        return Number(this.$route.params.Pid);
    },
  },
  methods: {
    filter_data: function() {
        this.$store.dispatch("report/getDebtReportDetail", this.uId);
        this.order_filter_data();
        this.deposit_filter_data();
    },
    order_filter_data: function() {
      var param = {
        pagination: this.order_pagination,
        filter: this.filterConditions,
        quickFilter: this.quickFilterConditions
      };
      param.filter = [
        {
            column: 'Status',
            value: [0,1,3,10],
            condition: 'not_in'
        },
        {
            column: 'UID',
            value: this.uId,
            condition: 'equal'
        }
      ]
      this.$store.dispatch("main_order/getListOrderDebts", param);
    },
    deposit_filter_data: function() {
      var param = {
        pagination: this.deposit_pagination,
        filter: this.filterConditions,
        quickFilter: this.quickFilterConditions
      };
      param.filter = [
        {
            column: 'Status',
            value: 1,
            condition: 'does_not_equal'
        },
        {
            column: 'UID',
            value: this.uId,
            condition: 'equal'
        }
      ]
      this.$store.dispatch("deposit/getList", param);
    },
    get_status_color(val, enums) {
      return this.$options.filters.display_color(val, enums);
    },
    get_order_status_color(value){
      const objStatus = configs.ORDER_STATUS.find(obj => obj.value === value);
      return objStatus ? objStatus.color : 'black';
    }
  },
  mounted() {
    this.filter_data();
    this.$root.$emit("REQUEST_ROOT_OPTION", {});
    this.$root.$on("REQUEST_REFRESH_DATA", this.filter_data);
  },
  beforeDestroy() {
    this.$root.$off("REQUEST_REFRESH_DATA", this.filter_data);
  }
};
</script>